import { render, staticRenderFns } from "./LocalizarLoja.vue?vue&type=template&id=1373d98d&scoped=true"
import script from "./LocalizarLoja.vue?vue&type=script&lang=js"
export * from "./LocalizarLoja.vue?vue&type=script&lang=js"
import style0 from "./LocalizarLoja.vue?vue&type=style&index=0&id=1373d98d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1373d98d",
  null
  
)

export default component.exports